import { Component } from '@angular/core';
import { fadeIn } from "assets/animations/animations";

@Component({
    selector: 'app-administration-data-cleanup-log-layout',
    templateUrl: './data-cleanup-log-layout.component.html',
    styleUrls: ['./data-cleanup-log-layout.component.scss'],
    animations: [fadeIn],
    standalone: false
})
export class DataCleanupLogLayoutComponent {

}
